module.exports = __webpack_public_path__ + "img/redBall.5e7968b3.svg";